import { Lock, Server, Shield, FileCheck, KeyRound, EyeOff } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";

const PILLARS = [
    {
        icon: Server,
        title: "Hébergement souverain",
        body: "Toutes vos données sont stockées en France chez un prestataire certifié ISO 27001 et HDS. Aucun transfert hors UE sans consentement explicite.",
    },
    {
        icon: Lock,
        title: "Chiffrement bout en bout",
        body: "TLS 1.3 en transit · AES-256 au repos · Chiffrement des justificatifs et données bancaires en base avec rotation périodique des clés.",
    },
    {
        icon: KeyRound,
        title: "Authentification renforcée",
        body: "JWT court (24h), refresh sécurisé, OAuth Google avec PKCE. 2FA et SSO disponibles sur le plan Business.",
    },
    {
        icon: EyeOff,
        title: "Principe du moindre privilège",
        body: "Aucun ingénieur Ticketify n'a accès à vos données sans procédure approuvée et journalisée. Pas d'analyse comportementale ni de vente à des tiers.",
    },
    {
        icon: FileCheck,
        title: "Conformité comptable",
        body: "Archivage légal 10 ans (art. L102 B LPF). Factures conformes art. 289 CGI. Export FEC en cours d'implémentation.",
    },
    {
        icon: Shield,
        title: "RGPD respecté",
        body: "Export complet de vos données (art. 20), suppression de compte (art. 17), DPO joignable à dpo@ticketify.fr.",
    },
];

export default function Security() {
    return (
        <div className="min-h-screen">
            <PublicHeader />

            <section className="pt-32 pb-12 sm:pt-44 sm:pb-16 px-6 sm:px-8 text-center">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#86868B] mb-3 tk-rise">Sécurité</p>
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#1D1D1F] tk-rise tk-rise-1 leading-[1.05]">
                    Vos données.<br />
                    <span className="bg-gradient-to-r from-[#007AFF] to-[#34C759] bg-clip-text text-transparent">
                        Vraiment vos données.
                    </span>
                </h1>
                <p className="mt-6 max-w-2xl mx-auto text-lg text-[#86868B] leading-relaxed tk-rise tk-rise-2">
                    Justificatifs comptables et infos bancaires&nbsp;: on traite ces données avec le même niveau
                    d&apos;exigence qu&apos;une banque.
                </p>
            </section>

            <section className="px-6 sm:px-8 pb-20">
                <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-5">
                    {PILLARS.map((p, i) => (
                        <div
                            key={p.title}
                            className="tk-card p-6 sm:p-7 tk-rise"
                            style={{ animationDelay: `${i * 80}ms` }}
                            data-testid={`security-pillar-${i}`}
                        >
                            <div className="flex items-start gap-4">
                                <div className="w-11 h-11 rounded-2xl bg-[#34C759]/12 flex items-center justify-center shrink-0">
                                    <p.icon className="w-5 h-5 text-[#34C759]" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-[#1D1D1F]">{p.title}</h3>
                                    <p className="mt-2 text-sm text-[#86868B] leading-relaxed">{p.body}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="px-6 sm:px-8 pb-24">
                <div className="max-w-3xl mx-auto tk-card p-8">
                    <h2 className="text-xl font-semibold text-[#1D1D1F]">Signaler une vulnérabilité</h2>
                    <p className="mt-3 text-sm text-[#86868B] leading-relaxed">
                        Si vous découvrez une faille de sécurité, contactez-nous à{" "}
                        <a href="mailto:security@ticketify.fr" className="text-[#007AFF] hover:underline">
                            security@ticketify.fr
                        </a>
                        . Nous appliquons une politique de disclosure responsable et remercions chaque
                        contribution avec un crédit Hall of Fame (et un cadeau si la faille est critique).
                    </p>
                </div>
            </section>

            <footer className="border-t border-black/5 py-10 px-6 sm:px-8 text-center text-sm text-[#86868B]">
                © 2026 Ticketify
            </footer>
        </div>
    );
}
